import "./chunk-EUXUH3YW.js";

// libs/widgets/src/lib/notifications/i18n/ar.ts
var ar_default = {
  "widgets.notifications.fusion-swap-view.status.pending": "\u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631",
  "widgets.notifications.fusion-swap-view.status.filled": "\u0645\u0643\u062A\u0645\u0644",
  "widgets.notifications.fusion-swap-view.status.false-predicate": "\u0645\u0639\u0628\u0623",
  "widgets.notifications.fusion-swap-view.status.not-enough-balance-or-allowance": "\u0645\u0639\u0628\u0623",
  "widgets.notifications.fusion-swap-view.status.partially-filled": "\u0645\u0639\u0628\u0623",
  "widgets.notifications.fusion-swap-view.status.wrong-permit": "\u0645\u0639\u0628\u0623",
  "widgets.notifications.fusion-swap-view.status.invalid-signature": "\u0645\u0639\u0628\u0623",
  "widgets.notifications.fusion-swap-view.status.expired": "\u0645\u0646\u062A\u0647\u064A \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629",
  "widgets.notifications.fusion-swap-view.status.cancelled": "\u0645\u0644\u063A\u0649",
  "widgets.notifications.fusion-swap-view.control.cancel": "\u0625\u0644\u063A\u0627\u0621"
};
export {
  ar_default as default
};
//# sourceMappingURL=ar-5E2DVKJM.js.map
